import { useMemo } from 'react';

import { MedicalInformation } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createTranslatedText, dateFormatter } from '@dreryk/react-common';
import { LinkSize, SidePanelListItem } from '@dreryk/react-components';

import { MedicalInformationModalOpener, MedicalInformationModalOpenLink } from '~legacy.patient';

import { HistoricalVisitsListItemHeader } from '../historicalVisits/HistoricalVisitsListItemHeader';

import { MedicalDataCategoryContent } from './MedicalDataCategoryContent';

export const useMedicalDataCategoryListItems = (
   medicalDataInformation: MedicalInformation[] | undefined,
   onMedicalDataAccessAuthorizationUpdate: VoidFunction
): SidePanelListItem[] | undefined => {
   return useMemo(() => {
      if (!medicalDataInformation) {
         return undefined;
      }
      return medicalDataInformation.map((medicalDataInformationEntry) => ({
         id: medicalDataInformationEntry.id,
         headerContent: (
            <HistoricalVisitsListItemHeader
               text={createTranslatedText(dateFormatter(medicalDataInformationEntry.creationDate))}
               icon={
                  <MedicalInformationModalOpener
                     medicalInformation={medicalDataInformationEntry}
                     onMedicalDataAccessAuthorizationUpdate={onMedicalDataAccessAuthorizationUpdate}
                  >
                     {({ openModal }) => (
                        <MedicalInformationModalOpenLink
                           onClick={openModal}
                           unsignedAttachmentCount={medicalDataInformationEntry.unsignedAttachmentCount}
                           size={LinkSize.SMALL}
                        />
                     )}
                  </MedicalInformationModalOpener>
               }
            />
         ),
         content: (
            <MedicalInformationModalOpener
               medicalInformation={medicalDataInformationEntry}
               onMedicalDataAccessAuthorizationUpdate={onMedicalDataAccessAuthorizationUpdate}
            >
               {({ openModal }) => (
                  <MedicalDataCategoryContent
                     medicalDataInformationEntry={medicalDataInformationEntry}
                     onShowMoreAttachmentsClick={openModal}
                  />
               )}
            </MedicalInformationModalOpener>
         ),
      }));
   }, [medicalDataInformation, onMedicalDataAccessAuthorizationUpdate]);
};
